/* External */
import { useMemo } from 'react';

/* Utils */
import { useIsBrazil } from '../../providers/ConfigProvider';
import {
  useAllGenres,
  useFullEpisodeName,
  isEpisode,
  isMovie,
  isEvent,
  isChannel,
  isSports,
  joinArrayWithSpace,
  getRating,
} from '../../utils/metaDataUtils';

export function useSubtitleLiveCard(content) {
  const isBrazil = useIsBrazil();

  const fullEpisodeName = useFullEpisodeName(content);
  const allGenres = useAllGenres(content);

  let baseSubtitle = content?.shortName;

  if (isEpisode(content)) baseSubtitle = fullEpisodeName;

  if (isMovie(content) || isEvent(content)
      || isChannel(content) || isSports(content)) {
    baseSubtitle = allGenres;
  }

  return useMemo(() => joinArrayWithSpace([
    isBrazil && getRating(content),
    baseSubtitle,
  ]), [baseSubtitle, content, isBrazil]);
}
